import React from 'react';
import { Link } from 'react-router-dom';

/**
 * Error boundary for a single page/content area.
 * Shows a fallback so the rest of the layout (e.g. sidebar) stays visible.
 */
class PageErrorBoundaryClass extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false, error: null };
  }

  static getDerivedStateFromError(error) {
    return { hasError: true, error };
  }

  componentDidCatch(error, errorInfo) {
    console.error('[PageErrorBoundary]', error, errorInfo);
  }

  render() {
    if (this.state.hasError) {
      return this.props.fallback ?? (
        <div className="flex flex-col items-center justify-center min-h-[320px] p-8 text-center">
          <p className="text-lg font-medium text-gray-700 dark:text-gray-300 mb-2">
            This page encountered an error.
          </p>
          <p className="text-sm text-gray-500 dark:text-gray-400 mb-4">
            Try refreshing or go back to the dashboard.
          </p>
          <Link
            to="/platform/dashboard"
            className="px-4 py-2 bg-blue-600 text-white rounded-lg hover:bg-blue-700"
          >
            Go to Dashboard
          </Link>
        </div>
      );
    }
    return this.props.children;
  }
}

export default function PageErrorBoundary({ children, fallback }) {
  return (
    <PageErrorBoundaryClass fallback={fallback}>
      {children}
    </PageErrorBoundaryClass>
  );
}
